import React, { useMemo } from "react";
import { BsPersonFill } from "react-icons/bs";
import { AttendanceMessage } from "../interfaces/Attendances.interfaces";
import { decodeSafeURI } from "./decodeSafeUri.hook";

/**
 * Analisa uma string VCard para extrair o nome do contato de forma otimizada.
 * @param vCardString A string VCard (pode estar codificada).
 * @returns O nome do contato.
 */
const parseVCardName = (vCardString: string): string => {
    try {
        const decodedString = decodeURIComponent(vCardString);
        const lines = decodedString.split('\n');
        let vCardName = 'Contato';
        for (const line of lines) {
            const trimmedLine = line.trim();
            if (trimmedLine.startsWith('FN:')) {
                vCardName = trimmedLine.substring(3);
                break;
            }
        }
        return vCardName;
    } catch (e) {
        return 'Contato';
    }
};

/**
 * Hook customizado que gera um resumo de uma mensagem para ser exibido na lista de atendimentos.
 * @param message O objeto da última mensagem, que pode ser nulo.
 * @returns Um ReactNode (JSX ou string) com o resumo formatado da mensagem.
 */
export const useMessageSummary = (message: AttendanceMessage | null) => {
    return useMemo(() => {
        if (!message) {
            return 'Nenhuma mensagem';
        }

        if (message.MENSAGEM && message.MENSAGEM.startsWith('BEGIN:VCARD')) {
            const contactName = parseVCardName(message.MENSAGEM);
            return (
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <BsPersonFill />
                    {contactName}
                </span>
            );
        }
        
        if (message.ARQUIVO && !message.MENSAGEM) {
            const fileType = message.ARQUIVO.TIPO.toUpperCase();
            if (fileType.includes("IMAGE")) return "📷 Imagem";
            if (fileType.includes("VIDEO")) return "📹 Vídeo";
            if (fileType.includes("AUDIO") || fileType.includes("PTT")) return "🎵 Áudio";
            return "📄 Documento";
        }

     const decodedText = message.MENSAGEM ? decodeSafeURI(message.MENSAGEM) : '';
     return decodedText;
    }, [message]);
};